import { CustomFooter } from './component';


export default CustomFooter;
